<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <fa-icon class="prompt-icon text-primary" [icon]="faIcon"></fa-icon>
</div>
<div class="modal-body">
    <p [innerHtml]="message"></p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="ok()">OK</button>
</div>
